import { useStaticQuery, graphql } from 'gatsby';

export const useComponents = () => {
  return useStaticQuery(graphql`
  query getComponents {
    allAirtableComponents {
      edges {
        node {
          data {
            Atomic_name
            Description
            Documentation
            Figma_Library
            Name
            Slug
            Type
            Package
            Web
            iOS
            Screenshots {
              localFiles {
                absolutePath
                relativePath
                url
                name
                publicURL
              }
            }
            Hero_Image {
              localFiles {
                absolutePath
                relativePath
                url
                name
                publicURL
              }
            }
            Gallery_Image {
              localFiles {
                absolutePath
                relativePath
                url
                name
                publicURL
              }
            }
          }
        }
      }
    }
  }
  
`);
};

export default useComponents;
